<template>
  <section class="policy-holder">
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules">
      <div class="flex">
        <div class="flex-1">
          <template>
            <section v-if="type === 1">
              <div class="form-item">
                <span>Title</span>
                <el-form-item
                  ref="isrd_title"
                  prop="isrd_title">
                  <v-select
                    v-model="formData.isrd_title"
                    :list="titleOptions"
                    :disabled="checkDisabled('isrd_title')"
                  />
                </el-form-item>
              </div>
              <div class="flex-sb">
                <div class="form-item form-half">
                  <span>Last Name</span>
                  <el-form-item
                    ref="isrd_lst_nm"
                    prop="isrd_lst_nm">
                    <v-input
                      v-model="formData.isrd_lst_nm"
                      uppercase
                      :disabled="checkDisabled('isrd_lst_nm')" />
                  </el-form-item>
                </div>
                <div class="form-item form-half">
                  <span>First Name</span>
                  <el-form-item
                    ref="isrd_fst_nm"
                    prop="isrd_fst_nm">
                    <v-input
                      v-model="formData.isrd_fst_nm"
                      uppercase
                      :disabled="checkDisabled('isrd_fst_nm')" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <span>Date of Birth</span>
                <el-form-item
                  ref="isrd_dob"
                  prop="isrd_dob">
                  <v-birth-day
                    v-model="formData.isrd_dob"
                    :disabled="checkDisabled('isrd_dob')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>HKID/Passport Number</span>
                <el-form-item
                  ref="id_type"
                  prop="id_type">
                  <v-radio-group
                    v-model="formData.id_type"
                    :disabled="checkDisabled('id_type')"
                    :list="personalIdTypOptions" />
                </el-form-item>
                <el-form-item
                  v-if="formData.id_type != 2"
                  ref="id_no"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    placeholder="A123456(3), please input A1234563"
                    :disabled="checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="pp_no"
                  prop="pp_no">
                  <v-input
                    v-model="formData.pp_no"
                    uppercase
                    :disabled="checkDisabled('pp_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Mobile Number</span>
                <el-form-item
                  ref="mobile_no"
                  prop="mobile_no">
                  <v-input
                    v-model="formData.mobile_no"
                    type="number"
                    :disabled="checkDisabled('mobile_no')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Email</span>
                <el-form-item
                  ref="email"
                  prop="email"
                  :rules="rules.email">
                  <v-input v-model="formData.email" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Occupation</span>
                <el-form-item
                  ref="occ_id"
                  prop="occ_id">
                  <v-select
                    v-model="formData.occ_id"
                    :list="localAllOptions.occupation" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Policyholder is one of the Named Driver?</span>
                <el-form-item
                  ref="hldr_is_drvr_ind"
                  prop="hldr_is_drvr_ind">
                  <v-radio-group
                    v-model="formData.hldr_is_drvr_ind"
                    :border="true"
                    :list="yesNoOptions" />
                </el-form-item>
              </div>
            </section>
            <section v-else>
              <div class="form-item">
                <span>Company Name</span>
                <el-form-item
                  ref="isrd_com_nm"
                  prop="isrd_com_nm">
                  <v-input
                    v-model="formData.isrd_com_nm"
                    uppercase
                    :disabled="checkDisabled('isrd_com_nm')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Business Registration Number</span>
                <el-form-item
                  ref="id_no"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    letterAndNumber
                    maxlength="8"
                    :disabled="checkDisabled('id_no')"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Company Phone No.</span>
                <el-form-item
                  ref="phone_no"
                  prop="phone_no">
                  <v-input
                    v-model="formData.phone_no"
                    type="number"
                    :disabled="checkDisabled('phone_no')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Company Email</span>
                <el-form-item
                  ref="email"
                  prop="email">
                  <v-input
                    v-model="formData.email"
                    :disabled="checkDisabled('email')" />
                </el-form-item>
              </div>
              <div class="form-block">
                <span>Contact Person Name</span>
                <el-form-item
                  ref="contact_nm"
                  prop="contact_nm">
                  <v-input
                    v-model="formData.contact_nm"
                    :disabled="checkDisabled('contact_nm')" />
                </el-form-item>
              </div>
              <div class="form-block">
                <span>Contact Person Mobile No.</span>
                <el-form-item
                  ref="contact_phone"
                  prop="contact_phone">
                  <v-input
                    v-model="formData.contact_phone"
                    type="number"
                    :disabled="checkDisabled('contact_phone')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Nature of Business</span>
                <el-form-item
                  ref="bsns_nature_id"
                  prop="bsns_nature_id">
                  <v-select
                    v-model="formData.bsns_nature_id"
                    :list="localAllOptions.industry"
                    :disabled="checkDisabled('bsns_nature_id')" />
                </el-form-item>
              </div>
            </section>
          </template>
        </div>
        <div class="flex-1 edit-holder-box">
          <div class="card">
            <span class="title">{{ formData.cust_typ === 1? 'Correspondence': 'Company' }} Address</span>
            <address-form
              ref="address-form"
              :isRequired="isRequired"
              :not-valid="!isRequired"
              :formType="1"
              :formDataLock="formDataLock"
              :disabled="disabled"
              :form="formData"
              @getFormData="getSubFormData" />
          </div>
        </div>
      </div>
    </el-form>

    <confirm-information
      ref="confirm-information"
      :upd_def_info="formData.updDefInfo"
      @confirm="handlerConfirmChangeInfo" />

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import AddressForm from '@/views/components/address-form'
import ConfirmInformation from '@/views/components/dialogs/confirm-information'
import dayjs from 'dayjs'
import {checkMobile} from '@/utils/validate'

export default {
  name: 'PolicyHolder',
  components: {
    AddressForm,
    ConfirmInformation
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.form
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    const checkIsEmail = (rule, value, callback) => {
      let {cust_typ} = this.form
      if(cust_typ!=1&&!val){
        callback( new Error(this.$t('placeholder.input')) )
      }
      callback()
    }
    const checkIdNo = (rule, value, callback) => {
      const { cust_typ, pp_no } = this.formData
      var reg = /[^\w\/]/
      if (cust_typ == 2 && value && reg.test(value)) {
        callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
      }
      // else {
      //   if(!pp_no && !value) {
      //     callback(new Error(this.$t('placeholder.input')))
      //   }
      // }
      callback()
    }
    return {
      oldFormDataLock: -1,
      formData: {
        updDefInfo: [],
        is_virgin: 0, // 判斷是否二次投保
        class_id: '',
        cust_typ: 1,
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_title: '',
        isrd_dob: '',
        id_type: '',
        id_no: '',
        pp_no: '',
        mobile_no: '',
        email: '',
        occ_id: '',
        isrd_com_nm: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        // contact_occ_id: '',
        // contact_mobile: '',
        contact_phone: '',
        hldr_is_drvr_ind: '',
        // contact_email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        isUpdatePolicyData: 0, // 用於判斷是否更新 customer 常置資料
      },
      subForm: {
        'address-form': false
      },
      oldFormData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_title: '',
        isrd_dob: '',
        id_type: '',
        id_no: '',
        pp_no: '',
        mobile_no: '',
        email: '',
        occ_id: '',
        isrd_com_nm: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        // contact_occ_id: '',
        contact_phone: '',
        // contact_email: ''
      },
      extraRules:{
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ],
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
        contact_phone: [
          { validator: checkMobile, trigger: ['change', 'blur'] }
        ],
        // email: [
        //   { validator: checkEmail, trigger: ['change', 'blur'] },
        //   { validator: checkIsEmail, trigger: ['change', 'blur'] },
        //
        // ],
      }
    }
  },
  computed: {
    formRules() {
      let extraRules=this.extraRules
      return this.checkRefer ===2 ? this.rules : extraRules
    },
    type() {
      return this.formData.cust_typ
    },
    // 判斷是否二次投保
    disabledVirgin() {
      const { is_virgin } = this.formData
      return is_virgin === 1? false: true
    },
    localAllOptions() {
      const classId = this.formData.class_id
      if(classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${classId}`]
      }
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
              // 用于匹配是否更新了信息
              if(key in this.oldFormData) {
                this.oldFormData[key] = val[key]
              }
            }
          })
          // 給 pp_no 賦值
          const { id_type, id_no, pp_no } = val
          if(id_type == 2 && !pp_no) {
            this.formData.pp_no = id_no
            this.oldFormData.pp_no = id_no
          }
        }
        // 用于匹配是否更新了信息
        // this.oldFormData = JSON.parse(JSON.stringify(this.formData))
      }
    },
    formData: {
      deep: true,
      handler(data) {
        const { hldr_is_drvr_ind, id_type, id_no, pp_no } = data
        let params = JSON.parse(JSON.stringify(data))
        if(this.type == 1 && hldr_is_drvr_ind == 1) {
          if(id_type == 2) {
            params.id_no = pp_no
          }
          this.$emit('change-driver', params)
          // this.$emit('one-driver', true)
        }
        // if(this.type ==1 && hldr_is_drvr_ind == 0)
        //   this.$emit('change-driver', params)

      }
    },
    'formData.hldr_is_drvr_ind': {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('one-driver', val == 1? true: false)
      }
    }
  },
  methods: {
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      return disable_filed.includes(field)
    },
    openConfirmDialog() {
      this.$refs['confirm-information'].changeDialog()
    },
    handlerConfirmChangeInfo(result) {
      this.$emit('confirm', result)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      if(this.formData.cust_typ == 2) {
        this.formData.id_type = 3
      }
      this.formData = Object.assign(this.formData, data)
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          // 校驗地址組件
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }
          // 判斷是否需要更新常置資料 -- 二次投保才要
          // if(this.disabledVirgin) {
          let isUpdate = false
          Object.keys(this.oldFormData).some(key => {
            if(this.oldFormData[key] != this.formData[key]) {
              isUpdate = true
              return true
            }
          })

          if(isUpdate) {
            this.formData.isUpdatePolicyData = 1
          }

          const updDefInfo = this.handler().checkUpdateInfo()
          // if(updDefInfo.length > 0) {
          this.formData.updDefInfo = updDefInfo
          // }


          // }
          let params = JSON.parse(JSON.stringify(this.formData))
          if(params.id_type == 2) {
            params.id_no = params.pp_no
          }

          this.$emit('getFormData', formName, params)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
      //
    },
    getSaveSubmitForm(formName){
      // 校驗地址組件
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      // if(Object.values(this.subForm).some(item => item === false)) {
      //   return
      // }
      // 判斷是否需要更新常置資料 -- 二次投保才要
      // if(this.disabledVirgin) {
      let isUpdate = false
      Object.keys(this.oldFormData).some(key => {
        if(this.oldFormData[key] != this.formData[key]) {
          isUpdate = true
          return true
        }
      })
      if(isUpdate) {
        this.formData.isUpdatePolicyData = 1
      }

      const updDefInfo = this.handler().checkUpdateInfo()
      // if(upd_def_info.length > 0) {
      this.formData.updDefInfo = updDefInfo
      // }

      // }
      let params = JSON.parse(JSON.stringify(this.formData))
      if(params.id_type == 2) {
        params.id_no = params.pp_no
      }

      this.$emit('getFormData', formName, params)
    },
    handler() {
      return {
        checkUpdateInfo: () => {
          const checkList = [
            {
              id: 'email',
              name: 'Email'
            },
            {
              id: 'occ_id',
              name: 'Occupation',
            },
            {
              id: 'bsns_nature_id',
              name: 'Nature of Business',
            },
            {
              id: 'contact_nm',
              name: 'Contact Name',
            },
            // {
            //   id: 'contact_occ_id',
            //   name: 'Occupation & Position',
            // },
            {
              id: 'contact_phone',
              name: 'Contact Number',
            },
            // {
            //   id: 'contact_email',
            //   name: 'Contact Email'
            // }
          ]

          let updDefInfo = []
          checkList.some(item => {
            if(this.oldFormData[item.id] != this.formData[item.id]) {
              updDefInfo.push(item)
            }
          })

          const addressList = [
            'addr_room',
            'addr_floor',
            'addr_block',
            'addr_building',
            'addr_street',
            'addr_region',
            'addr_area',
            'addr_district'
          ]
          addressList.some(key => {
            if(this.oldFormData[key] != this.formData[key]) {
              updDefInfo.push({
                id: 'mailing_address',
                name: 'Correspondence Address'
              })
              return true
            }
          })

          // if(upd_def_info.length > 0) {
          //   this.formData.upd_def_info = upd_def_info
          // }
          return updDefInfo
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-holder {
    // .label {
    //         display: block;
    //         margin-bottom: 5px;
    //         font-size: 14px;
    //         font-weight: 500;
    //         color: #616266;
    //     }
    .edit-holder-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 20px;
      .card {
        padding-bottom: 40px;
      }
    }
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    .form-flex {
      display: flex;
      justify-content: space-between;
      & > .form-block {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .form-block {
    margin-bottom: 15px;
    & > span:first-child {
      display: block;
      padding-bottom: 5px;
      font-weight: 500;
      font-size: 14px;
    }
  }
}
</style>
